import More from 'components/pages/More/More';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('account');
export default buildPage(More, {
  requiresAuthentication: true,
  fullPageWidth: false,
  metaData: {
    title: 'More',
    description: 'More options',
  },
});
